import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setListId } from "../store/slices/ownerSlice";
import ProspectMain from "../components/propects/ProspectMain";

type Props = { utils: any; setShowExpiredAlert: any };

const ProspectDetail = (props: Props) => {
  const { listId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!listId) return;
    dispatch(setListId(listId));
  }, [dispatch, listId]);

  return (
    <div className="flex h-full min-h-0 w-full bg-background-grey">
      <ProspectMain utils={props.utils} setShowExpiredAlert={props.setShowExpiredAlert} view="detail" />
    </div>
  );
};

export default ProspectDetail;
